import React, { useEffect, useState } from "react";
import Footer from "../../stories/Footer";
import Header from "../../stories/Header";
import classes from "./DetailForm.module.css";
import { Row, Col, Container, Form } from "react-bootstrap";
import Button from "../../stories/Button/Button";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  apiHeader,
  BaseURL,
  falsyArray,
  formRegEx,
  formRegExReplacer,
} from "../../config/apiUrl";
import { toast } from "react-toastify";
import Input from "../../stories/Input";
import { Post } from "../../Axios/AxiosFunctions";
import LastStepModal from "../../stories/LastStepModal/LastStepModal";
import { saveLocation } from "../../redux/common/commonSlice";

const Index = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const navigate = useNavigate();
  const { access_token: token, user } = useSelector(
    (state) => state?.authReducer
  );
  const cardTags = useSelector((state) => state?.commonReducer?.tags);
  const generatedImages = useLocation()?.state;

  const [tags, setTags] = useState("");
  const [authorName, setAuthorName] = useState(user?.firstName);
  const [quantity, setQuantity] = useState(0);
  const [description, setDescription] = useState("");
  const [isApiCall, setIsApiCall] = useState(false);
  const [isLastStepModalOpen, setIsLastStepModalOpen] = useState(false);
  const [mainFormData, setMainFormData] = useState(null);

  useEffect(() => {
    if (!isLastStepModalOpen) setMainFormData(null);
  }, [isLastStepModalOpen]);

  // handle Submit
  const handlePublish = async (e) => {
    e.preventDefault();

    const params = {
      name: authorName,
      quantity,
      description,
      photo: generatedImages?.front,
      backPhoto: generatedImages?.back,
    };

    // val;idate
    for (let key in params)
      if (falsyArray.includes(params[key]))
        return toast.warn(
          `${key.replace(formRegEx, formRegExReplacer)} can not be empty.`
        );

    // validate tags
    const _tags = tags?.map((e) => e?._id);
    if (_tags?.length === 0) return toast.warn("Please select atleast 1 tag.");

    // create formdata
    const formData = new FormData();
    for (let key in params) formData.append(key, params[key]);
    for (let key in _tags) formData.append("tags[]", _tags[key]);

    // if user is not logged in => prompt signup modal
    if (!token) {
      setMainFormData(formData);
      return setIsLastStepModalOpen(true);
    }

    const url = BaseURL("cards/request");

    setIsApiCall(true);
    const response = await Post(url, formData, apiHeader(token, true));
    setIsApiCall(false);

    if (response !== undefined) {
      toast.success("Card Request sent successfully.");
      navigate("/my-cards");
    } else {
      for (let key in params) formData.delete(key);
    }
  };

  useEffect(() => {
    if (!generatedImages) return navigate(-1);
  }, []);

  return (
    <>
      <Header />
      <section>
        <Container className={classes.container}>
          <Row>
            <Col lg={8}>
              <h2 className={classes.detail_heading}>CARD DETAIL</h2>
              <div className={classes.detailForm_main}>
                <Form onSubmit={handlePublish}>
                  <Row className={classes.detailForm_row}>
                    <Col lg={6}>
                      <Input
                        type="text"
                        placeholder="Author Name"
                        label="Author Name"
                        value={authorName}
                        setter={setAuthorName}
                      />
                    </Col>
                    <Col lg={6}>
                      <Input
                        type="number"
                        placeholder="Quantity"
                        label="Quantity"
                        value={quantity}
                        setter={setQuantity}
                        min={1}
                      />
                    </Col>
                  </Row>

                  <Row className={classes.detailForm_row1}>
                    <Col lg={6}>
                      <label className={classes?.tagLabel}>Tags</label>
                      <div className={classes.featured_dropDown_main}>
                        <Select
                          placeholder="Select Tags"
                          options={cardTags}
                          isMulti
                          value={tags}
                          onChange={(e) => setTags(e)}
                          getOptionLabel={(op) => op?.name}
                          getOptionValue={(op) => op?.name}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className={classes.detailForm_row1}>
                    <label className={classes?.tagLabel}>Description</label>
                    <Col lg={12}>
                      <Form.Control
                        className={classes.form_fields}
                        as="textarea"
                        rows={8}
                        placeholder="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className={classes.detailForm_row1}>
                    <Button
                      disabled={isApiCall}
                      label={
                        isApiCall ? "Please Wait..." : "Submit for Approval"
                      }
                      className={classes.publish_btn}
                    />
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />

      <LastStepModal
        show={isLastStepModalOpen}
        setShow={setIsLastStepModalOpen}
        formData={mainFormData}
      />
    </>
  );
};

export default Index;
